import React, { useState, useEffect } from "react";
import { Users as UsersIcon, UserPlus, Shield, ShieldAlert, ShieldCheck, Mail, Phone, X, CheckCircle, Pencil, Trash2 } from "lucide-react";
import { api } from "../../utils/api";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editingId, setEditingId] = useState(null); // Düzenlenen kişinin ID'si
  
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    role: "Denetçi",
    active: true
  });

  const load = () => {
    setLoading(true);
    api.get("/users")
      .then(r => {
        setUsers(r.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const change = e => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  // YENİ EKLEME PENCERESİ
  const startNew = () => {
    setEditingId(null);
    setForm({ name: "", email: "", phone: "", password: "", role: "Denetçi", active: true });
    setModal(true);
  };

  // DÜZENLEME PENCERESİ
  const startEdit = (u) => {
    setEditingId(u.id);
    setForm({
      name: u.name || "",
      email: u.email || "",
      phone: u.phone || "",
      password: "", // Düzenlemede şifre boş gelir. Kullanıcı yeni şifre yazmazsa eski şifresi korunur.
      role: u.role || "Denetçi",
      active: u.active ?? true
    });
    setModal(true);
  };

  // SİLME İŞLEMİ
  const removeUser = async (id, role) => {
    if (role === "Süper Yönetici") {
      alert("Sistem güvenliği için 'Süper Yönetici' hesabı silinemez!");
      return;
    }
    if (!window.confirm("Bu kullanıcıyı kalıcı olarak silmek istediğinize emin misiniz?")) return;
    
    try {
      await api.delete(`/users/${id}`);
      load();
    } catch (err) {
      alert("Kullanıcı silinemedi.");
    }
  };

  // KAYDET / GÜNCELLE İŞLEMİ
  const submit = async e => {
    e.preventDefault();
    try {
      if (editingId) {
        // Düzenleme
        await api.put(`/users/${editingId}`, form);
      } else {
        // Yeni Kayıt
        await api.post("/users", form);
      }
      setModal(false);
      load();
    } catch (x) {
      alert(x.response?.data?.detail || "İşlem sırasında bir hata oluştu. E-posta adresi kullanımda olabilir.");
    }
  };

  return (
    <div style={{ animation: "fadeIn 0.4s ease-out" }}>
      
      {/* ÜST BAŞLIK */}
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", background: "white", padding: "24px 30px", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.02)", marginBottom: "24px", gap: "20px" }}>
        <div>
          <span style={{ fontSize: "12px", fontWeight: "bold", color: "#3b82f6", letterSpacing: "1px", textTransform: "uppercase" }}>SİSTEM GÜVENLİĞİ</span>
          <h2 style={{ margin: "6px 0", fontSize: "24px", color: "#1e293b" }}>Yetkilendirme ve Kullanıcılar</h2>
          <p style={{ margin: 0, fontSize: "14px", color: "#64748b" }}>Yönetim paneline erişebilecek yöneticileri ve denetçileri (görüntüleyicileri) yönetin.</p>
        </div>
        <button 
          onClick={startNew} 
          style={{ display: "flex", alignItems: "center", gap: "8px", background: "#3b82f6", color: "white", border: "none", padding: "12px 22px", borderRadius: "10px", fontWeight: "bold", fontSize: "14px", cursor: "pointer", boxShadow: "0 4px 12px rgba(59, 130, 246, 0.25)" }}
        >
          <UserPlus size={18} /> Yeni Kullanıcı Ekle
        </button>
      </div>

      {/* KULLANICI LİSTESİ */}
      {loading ? (
        <div style={{ padding: "40px", textAlign: "center", color: "#64748b" }}>Kullanıcılar yükleniyor...</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: "20px" }}>
          {users.map((u, i) => (
            <div key={i} style={{ background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", padding: "24px", display: "flex", flexDirection: "column", gap: "16px", boxShadow: "0 2px 4px rgba(0,0,0,0.02)", position: "relative", overflow: "hidden" }}>
              
              <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "4px", background: u.role === "Süper Yönetici" ? "#8b5cf6" : u.role === "Yönetici" ? "#3b82f6" : "#10b981" }} />

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <h3 style={{ margin: "0 0 4px 0", fontSize: "18px", color: "#1e293b", display: "flex", alignItems: "center", gap: "8px" }}>
                    {u.name}
                  </h3>
                  <span style={{ 
                    display: "inline-flex", alignItems: "center", gap: "4px", padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "bold",
                    background: u.role === "Süper Yönetici" || u.role === "Yönetici" ? "#eff6ff" : "#ecfdf5",
                    color: u.role === "Süper Yönetici" || u.role === "Yönetici" ? "#2563eb" : "#059669"
                  }}>
                    {u.role === "Süper Yönetici" || u.role === "Yönetici" ? <ShieldCheck size={14}/> : <Shield size={14}/>}
                    {u.role}
                  </span>
                </div>
                {u.active ? (
                  <span style={{ color: "#16a34a", display: "flex", alignItems: "center", gap: "4px", fontSize: "12px", fontWeight: "600" }}><CheckCircle size={14}/> Aktif</span>
                ) : (
                  <span style={{ color: "#ef4444", display: "flex", alignItems: "center", gap: "4px", fontSize: "12px", fontWeight: "600" }}><ShieldAlert size={14}/> Pasif</span>
                )}
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "4px", paddingTop: "16px", borderTop: "1px dashed #cbd5e1" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color: "#475569", fontSize: "14px" }}>
                  <Mail size={16} color="#94a3b8" /> {u.email}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color: "#475569", fontSize: "14px" }}>
                  <Phone size={16} color="#94a3b8" /> {u.phone || "Telefon belirtilmemiş"}
                </div>
              </div>

              {/* DÜZENLE VE SİL BUTONLARI */}
              <div style={{ display: "flex", gap: "8px", marginTop: "auto", paddingTop: "12px" }}>
                <button onClick={() => startEdit(u)} style={{ flex: 1, background: "#f8fafc", color: "#3b82f6", border: "1px solid #e2e8f0", padding: "8px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", fontSize: "13px", fontWeight: "600", transition: "0.2s" }} onMouseOver={e => e.currentTarget.style.background = '#eff6ff'} onMouseOut={e => e.currentTarget.style.background = '#f8fafc'}>
                  <Pencil size={15} /> Düzenle
                </button>
                <button onClick={() => removeUser(u.id, u.role)} style={{ flex: 1, background: "#f8fafc", color: "#ef4444", border: "1px solid #e2e8f0", padding: "8px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", fontSize: "13px", fontWeight: "600", transition: "0.2s" }} onMouseOver={e => e.currentTarget.style.background = '#fef2f2'} onMouseOut={e => e.currentTarget.style.background = '#f8fafc'}>
                  <Trash2 size={15} /> Sil
                </button>
              </div>

            </div>
          ))}
        </div>
      )}

      {/* MODAL PENCERESİ */}
      {modal && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
          <div style={{ background: "white", width: "100%", maxWidth: "500px", borderRadius: "20px", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)", overflow: "hidden" }}>
            
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 24px", borderBottom: "1px solid #e2e8f0", background: "#f8fafc" }}>
              <div>
                <h2 style={{ margin: 0, fontSize: "18px", color: "#1e293b" }}>{editingId ? "Kullanıcıyı Düzenle" : "Yeni Kullanıcı Ekle"}</h2>
                <span style={{ fontSize: "13px", color: "#64748b" }}>Yönetim paneline giriş yapacak kişiyi tanımlayın.</span>
              </div>
              <button onClick={() => setModal(false)} style={{ background: "none", border: "none", color: "#64748b", cursor: "pointer" }}><X size={24} /></button>
            </div>

            <form onSubmit={submit} style={{ padding: "24px" }}>
              <div style={{ marginBottom: "16px" }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>Adı Soyadı *</label>
                <input name="name" value={form.name} onChange={change} required placeholder="Adı Soyadı" style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none" }} />
              </div>

              <div style={{ marginBottom: "16px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>E-posta (Giriş ID) *</label>
                  <input type="email" name="email" value={form.email} onChange={change} required placeholder="ornek@site.com" style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none" }} />
                </div>
                <div>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>Telefon No</label>
                  <input name="phone" value={form.phone} onChange={change} placeholder="532......." style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none" }} />
                </div>
              </div>

              <div style={{ marginBottom: "16px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>Sistem Yetkisi *</label>
                  <select name="role" value={form.role} onChange={change} style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", background: "white", fontWeight: "bold", color: form.role === "Yönetici" || form.role === "Süper Yönetici" ? "#2563eb" : "#059669" }}>
                    {form.role === "Süper Yönetici" && <option value="Süper Yönetici">Süper Yönetici</option>}
                    <option value="Denetçi">Denetçi (Sadece Görüntüler)</option>
                    <option value="Yönetici">Yönetici (Tam Yetkili)</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>
                    Giriş Şifresi {!editingId && "*"}
                  </label>
                  <input type="password" name="password" value={form.password} onChange={change} required={!editingId} placeholder={editingId ? "Değiştirmeyecekseniz boş bırakın" : "En az 6 karakter"} style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none" }} />
                </div>
              </div>

              <div style={{ marginBottom: "20px", background: "#f8fafc", padding: "12px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "bold", color: form.active ? "#16a34a" : "#ef4444" }}>
                  <input type="checkbox" name="active" checked={form.active} onChange={change} style={{ width: "16px", height: "16px" }} />
                  {form.active ? "Kullanıcı Aktif (Sisteme Giriş Yapabilir)" : "Kullanıcı Pasif (Sisteme Giriş Yapamaz)"}
                </label>
              </div>

              {form.role === "Denetçi" && (
                <div style={{ background: "#ecfdf5", padding: "12px", borderRadius: "8px", fontSize: "13px", color: "#065f46", marginBottom: "20px" }}>
                  <strong>Bilgi:</strong> "Denetçi" rolü sadece raporları ve kayıtları inceleyebilir, herhangi bir makbuz, aidat veya kullanıcı bilgisini değiştiremez veya silemez.
                </div>
              )}

              <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
                <button type="button" onClick={() => setModal(false)} style={{ padding: "12px 20px", background: "white", border: "1px solid #cbd5e1", borderRadius: "8px", color: "#475569", fontWeight: "600", cursor: "pointer" }}>Vazgeç</button>
                <button type="submit" style={{ padding: "12px 24px", background: "#3b82f6", border: "none", borderRadius: "8px", color: "white", fontWeight: "bold", cursor: "pointer", boxShadow: "0 2px 10px rgba(59,130,246,0.3)" }}>
                  {editingId ? "Değişiklikleri Kaydet" : "Kullanıcıyı Kaydet"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
}